import { InjectionToken } from '@angular/core';
import { DEFAULT_ROUTER_FEATURENAME, RouterReducerState, routerReducer } from '@ngrx/router-store';
import { Action, ActionReducerMap, MetaReducer, createFeatureSelector } from '@ngrx/store';

import {
  FeatureState as BusinessProcessesFeatureState,
  featureKey as businessProcessesFeatureKey,
  businessProcessesMetaReducer,
  businessProcessesReducer,
} from '@stores/business-processes';
import { FeatureState as CoreFeatureState, featureKey as coreFeatureKey, coreReducer } from '@stores/core';
import { coreMetaReducer } from '@stores/core/core.meta-reducer';
import { FeatureState as CrisisFeatureState, featureKey as crisisFeatureKey, crisisReducer } from '@stores/crisis';
import { MessagesState as MessagesFeatureState, featureKey as messagesFeatureKey, messagesReducer } from '@stores/messages';
import { FeatureState as MetaDataFeatureState, featureKey as metadataFeatureKey, metadataReducer } from '@stores/meta-data';

export interface State {
  [DEFAULT_ROUTER_FEATURENAME]: RouterReducerState;
  [coreFeatureKey]: CoreFeatureState;
  [crisisFeatureKey]: CrisisFeatureState;
  [businessProcessesFeatureKey]: BusinessProcessesFeatureState;
  [messagesFeatureKey]: MessagesFeatureState;
  [metadataFeatureKey]: MetaDataFeatureState;
}

export const rootReducer = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers token', {
  factory: () => ({
    [DEFAULT_ROUTER_FEATURENAME]: routerReducer,
    [coreFeatureKey]: coreReducer,
    [crisisFeatureKey]: crisisReducer,
    [businessProcessesFeatureKey]: businessProcessesReducer,
    [messagesFeatureKey]: messagesReducer,
    [metadataFeatureKey]: metadataReducer,
  }),
});

export const rootMetaReducers: MetaReducer[] = [coreMetaReducer, businessProcessesMetaReducer];

export const selectRouter = createFeatureSelector<RouterReducerState>(DEFAULT_ROUTER_FEATURENAME);
